<!--
    Desarrollado por: Ing. Wuilmer garcia
    // Fecha: 2021/04/04
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- formulario del Colegio -->

        <v-form ref="formDatos" lazy-validation>
            <v-dialog v-model="estadoComp" persistent scrollable max-width="60%">
                <v-card>
                    <v-card-title class="modal_title">
                        <v-row class="d-flex justify-space-between py-2"> 
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title> 

                    <v-divider></v-divider>


                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-select v-model="configuracion.id_perfil" :items="perfil"
                                label="Perfil" @change="cargarSubModulo"
                                item-value="id" item-text="descripcion_perfil"
                                :rules="[validation.selectReq]">
                                </v-select>
                            </v-col>                         

                            <v-col cols="12" sm="6" md="6">
                                <v-select v-model="configuracion.id_modulo" :items="modulo"
                                label="Módulo" @change="cargarSubModulo"
                                item-value="id" item-text="nombre_modulo"
                                :rules="[validation.selectReq]">
                                </v-select>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col v-for="x in 2" :key="x" cols="6">
                                <v-row>
                                    <v-col cols class="py-0">
                                        <label class="font-weight-black black--text"><h3>Submódulos</h3></label>
                                    </v-col>

                                    <v-col cols="1" class="py-0 btn_ver">
                                        <v-tooltip bottom color="#1b1b1b">
                                            <template v-slot:activator="{ on }">
                                                <v-icon dark small v-on="on">fa-eye</v-icon>
                                            </template>
                                            <span>VISUALIZAR</span>
                                        </v-tooltip>
                                    </v-col>

                                    <v-col cols="1" class="py-0 modal_title">
                                        <v-tooltip bottom color="#1b1b1b">
                                            <template v-slot:activator="{ on }">
                                                <v-icon dark small v-on="on">fa-plus</v-icon>
                                            </template>
                                            <span>AGREGAR</span>
                                        </v-tooltip>
                                    </v-col>

                                    <v-col cols="1" class="py-0 btn_editar">
                                        <v-tooltip bottom color="#1b1b1b">
                                            <template v-slot:activator="{ on }">
                                                <v-icon dark small v-on="on">fa-pencil-alt</v-icon>
                                            </template>
                                            <span>EDITAR</span>
                                        </v-tooltip>
                                    </v-col>

                                    <v-col cols="1" class="py-0 btn_eliminar">
                                        <v-tooltip bottom color="#1b1b1b">
                                            <template v-slot:activator="{ on }">
                                                <v-icon dark small v-on="on">fa-trash-alt</v-icon>
                                            </template>
                                            <span>BORRAR</span>
                                        </v-tooltip>
                                    </v-col>

                                </v-row>
                            </v-col>

                            <!--
                                // recorro los Sub Modulos
                                // y asigno el array del modelo que se chequea  visualizarSubMod
                            -->
                            <v-col cols="6" v-for="item in this.confSubModulo" :key="item.id">
                                <v-row>
                                    <v-col cols class="py-0">
                                        <label class="black--text">{{item.nombre_submodulo}}</label>
                                    </v-col>

                                    <v-col cols="1" class="py-0">
                                        <v-checkbox v-model="visualizarSubMod" :value="item.id"
                                            class="my-0" color="#388e3c" hide-details>
                                        </v-checkbox>
                                    </v-col>

                                    <v-col cols="1" class="py-0">
                                        <v-checkbox v-model="agregarSubMod" :value="item.id"
                                            class="my-0" color="#01579b" hide-details>
                                        </v-checkbox>
                                    </v-col>


                                    <v-col cols="1" class="py-0">
                                        <v-checkbox v-model="editarSubMod" :value="item.id"
                                            class="my-0" color="#ffbc00" hide-details >
                                        </v-checkbox>
                                    </v-col>

                                    <v-col cols="1" class="py-0">
                                        <v-checkbox v-model="borrarSubMod" :value="item.id"
                                            class="my-0" color="#e53935" hide-details>
                                        </v-checkbox>
                                    </v-col>

                                </v-row>

                                <v-divider/>
                            </v-col>

                        </v-row>
                    </v-card-text>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="btn_style3" dark tile @click="$emit('close')">Cancelar</v-btn>

                        <v-btn class="btn_block_style2" dark tile @click="saveItem()">Guardar Cambios</v-btn>


                    </v-card-actions>

                        <span v-if="test">

                            <code>
                                 Parametros :
                                {{parametros}}
                            </code>

                            <code>      
                                <br>
                                visualizar :
                                {{visualizarSubMod}}
                                agregar :
                                {{agregarSubMod}}
                                Editar :
                                {{editarSubMod}}
                                Borrar :
                                {{borrarSubMod}}
                            </code>
                        </span>

                     </v-card>
               
            </v-dialog>


           
        </v-form>

        <!-- fin modal del Colegio -->



    </div>
</template>

<script>

    import axios from "@/helpers/axios";
    import { validation } from "@/helpers/validator.js";
    import {mapActions, mapGetters, mapMutations } from 'vuex';


    export default {
        name:'ConfiguracionComp',

        // props:['estadoComp' , 'parametros'],
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },

        mounted() {  
            this.loadMain()
        },


        data(){
            return{
                session: sessionStorage,
                test:false,
                
                formTitle :   'Configuración de Módulos',
                modulo: [],
                perfil: [],

                confPerfil: [],
                configuracion:{}, // objeto de configuracion
                licenciaTipo  :[],
                confSubModulo  : [],

                // Perfil Chequeados

                visualizarSubMod : [],
                agregarSubMod : [],
                editarSubMod : [],
                borrarSubMod : []

            }
        },
       
      

        //computadas
        computed: {
         
            ...mapGetters('login', [ 'componenteEvento']),   
            
            validation() {
                return validation;
            },

       
        },

               
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp() {
                if(this.estadoComp){
                    this.loadMain()                    
                }else{   
                    //this.parametros = {}
                    this.limpiarForm()
                 
                }
            }
        },
        

        methods: {

            ...mapActions('login',['parametroComponente'] ),
            ...mapMutations('mensajeSis', ['setEnviarMens']),


            async loadMain(){

                try{
                this.limpiarForm() 
                this.configuracion.id_perfil = this.parametros.id_perfil
                // this.$refs.formDatos.resetValidation()
                              
                let response = await axios.get("/sistema/perfil/getQueryConfPerfil")
                    this.perfil = response.data.perfil
                    this.modulo = response.data.modulo

                    
                
                }catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }

            },

        


            limpiarForm(){
                this.configuracion = { id_perfil: '', id_licencia_tipo: '',
                                   id_modulo: null,
                                 id_usuario: this.session.id, 
                                }
                                
                this.confSubModulo = []
                this.resetValidation()
            },


            // Validar resetear campos al guardar
            resetValidation() {
                this.$refs.formDatos.resetValidation()
            },


            // carga las consultas de los submodulos segun el modulo seleccionad
            async cargarSubModulo(){
                if( (this.configuracion.id_perfil != null && this.configuracion.id_modulo != null) ){
                    try{
                        let resp = await axios.post("/sistema/perfil/confModuloPerfil", this.configuracion)

                        this.confSubModulo = resp.data.subModulo
                        let visualizar    = resp.data.visualizarSubMod
                        let agregar       = resp.data.agregarSubMod
                        let editar        = resp.data.editarSubMod
                        let borrar        = resp.data.borrarSubMod
                        
 
                        this.visualizarSubMod = visualizar.map(function (obj) {
                                                    return obj.id_submodulo;
                                                }); 
                        this.agregarSubMod    = agregar.map(function (obj) {
                                                    return obj.id_submodulo;
                                                });                  
                        this. editarSubMod    = editar.map(function (obj) {
                                                    return obj.id_submodulo;
                                                });
                        this.borrarSubMod     = borrar.map(function (obj) {
                                                    return obj.id_submodulo;
                                                }); 

                    }
                    catch(error){
                        this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                    }
                }
            },



             // Guarda los Perfiles
            async saveItem(){
                if (this.$refs.formDatos.validate()) {

                    try{

                        let params = {configuracion : this.configuracion,  
                                    visualizarSubMod :this.visualizarSubMod, agregarSubMod :this.agregarSubMod,
                                     editarSubMod :this. editarSubMod, borrarSubMod :this.borrarSubMod,
                                    id_usuario :this.session.id, id_empresa:this.session.id_empresa}
                        await axios.post("/sistema/perfil/saveConfig",params)

                        this.setEnviarMens({tipo:"S", mensaje: `Registro guardado con éxito`, tiempo:null})
                        
                        // No cerrar Para seguir configurando
                        // this.limpiarForm()
                        // this.$emit('reloadComp','perfilConfig')

                    }

                    catch(e){
                        if (e.response) {
                            let resp = e.response.data
                            console.log(resp)
                            this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                        }
                    }
                }
            },

           

            
                                    
        
            

            

           

        },
    }
</script>


<style scoped>
</style>